export enum ProfileScreens {
  PROFILE_SCREEN = "profileScreen",
  BADGE_SETUP = "badge-association",
}
